import React from 'react';
import classNames from 'classnames';

import {
  Faq,
  ProductStatus,
  SectionTitle,
  Tab,
  TabContent,
  TabContentItem,
  TabPanel,
  Tabs,
} from '@/ui/index';

import styles from './RoamingActivation.module.scss';

const RoamingActivation = ({ data }) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const renderTabs = (item, index) => {
    return (
      <Tab
        key={index}
        onClick={() => setActiveTab(index)}
        className={styles.customTab}
        itemScope
        itemType='http://schema.org/ListItem'
      >
        {item?.title}
      </Tab>
    );
  };

  const renderTabContents = (item, index) => {
    return (
      <TabContentItem
        key={index}
        itemScope
        itemType='http://schema.org/ItemList'
      >
        <ProductStatus
          dark
          statusData={item}
          className={classNames(['small-margin', styles.productStatus])}
          isBlock
        />
      </TabContentItem>
    );
  };

  return (
    <div
      className={classNames(['wrapper', 'section', styles.roaming_activation])}
      itemScope
      itemType='http://schema.org/CheckOutAction'
    >
      <div>
        <SectionTitle className={styles.title}>{data?.title}</SectionTitle>
        <Tabs active={activeTab}>
          <TabPanel>{data?.sections?.map(renderTabs)}</TabPanel>
          <TabContent>{data?.sections?.map(renderTabContents)}</TabContent>
        </Tabs>
      </div>
      {!!data?.sections[activeTab]?.accordion?.sections && (
        <Faq
          items={data?.sections[activeTab]?.accordion}
          className={styles.faq}
        />
      )}
    </div>
  );
};

export default RoamingActivation;
